import type { SVGProps } from "react";

const base: SVGProps<SVGSVGElement> = { fill: "none", "aria-hidden": true };

export const IconPlay = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M8 5v14l11-7L8 5Z" fill="currentColor" />
  </svg>
);

export const IconArrowRight = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconChevDown = (p: SVGProps<SVGSVGElement>) => (
  <svg width={12} height={12} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m6 9 6 6 6-6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconChevLeft = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m15 6-6 6 6 6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconChevRight = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m9 6 6 6-6 6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconClose = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

export const IconGrid = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={1.7} />
    <rect x="13" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={1.7} />
    <rect x="4" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={1.7} />
    <rect x="13" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth={1.7} />
  </svg>
);

export const IconStar = (p: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m12 3 2.7 6 6.3.6-4.7 4.3 1.3 6.1L12 17l-5.6 3 1.3-6.1L3 9.6 9.3 9 12 3Z" fill="currentColor" />
  </svg>
);

export const IconSpark = (p: SVGProps<SVGSVGElement>) => (
  <svg width={11} height={11} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m8 3 1 4-4 1 4 1-1 4 4-1 1 4 1-4 4 1-4-1 1-4-4 1 1-4-2 1-2-1Z" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
  </svg>
);

export const IconSparkleLg = (p: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m12 3 2 5 5 2-5 2-2 5-2-5-5-2 5-2 2-5Z" stroke="white" strokeWidth={2.2} strokeLinejoin="round" />
  </svg>
);

export const IconCheck = (p: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
    <path d="m5 12 4 4 10-12" stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconTarget = (p: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
    <circle cx="12" cy="12" r="6" stroke="white" strokeWidth={2.6} fill="none" />
    <circle cx="12" cy="12" r="2" fill="white" />
  </svg>
);

export const IconLineUp = (p: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M4 17l5-5 4 4 7-9" stroke="white" strokeWidth={2.6} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconDatabase = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <ellipse cx="12" cy="6" rx="8" ry="3" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
    <path d="M4 6v6c0 1.66 3.58 3 8 3s8-1.34 8-3V6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path d="M4 12v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

export const IconPenAI = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M12 20h9" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19 7l1.5-1.5" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" opacity={0.5} />
    <circle cx="21" cy="4" r="1.2" fill="currentColor" opacity={0.7} />
  </svg>
);

export const IconSideBySide = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <rect x="2" y="4" width="9" height="16" rx="2" stroke="currentColor" strokeWidth={2} />
    <rect x="13" y="4" width="9" height="16" rx="2" stroke="currentColor" strokeWidth={2} />
    <path d="M6 9h5M6 12h3M17 9h-2M17 12h-4" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" />
  </svg>
);

export const IconPublish = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M12 3v12m0-12-4 4m4-4 4 4" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

export const IconStructure = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <rect x="3" y="3" width="7" height="5" rx="1.5" stroke="currentColor" strokeWidth={2} />
    <rect x="14" y="3" width="7" height="5" rx="1.5" stroke="currentColor" strokeWidth={2} />
    <rect x="8.5" y="16" width="7" height="5" rx="1.5" stroke="currentColor" strokeWidth={2} />
    <path d="M6.5 8v3.5H12m0 0v4.5m0-4.5h5.5V8" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconShieldCheck = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M12 3 4 6v6c0 5 3.6 8.7 8 10 4.4-1.3 8-5 8-10V6l-8-3Z" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconAlignLeft = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <path d="M3 6h18M3 10h12M3 14h18M3 18h12" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <circle cx="20" cy="18" r="3.5" fill="currentColor" opacity={0.18} stroke="currentColor" strokeWidth={1.5} />
    <path d="m18.8 18 .8.8 1.6-1.6" stroke="currentColor" strokeWidth={1.4} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconUserControl = (p: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 24 24" {...base} {...p}>
    <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth={2} />
    <path d="M2 21c0-4 3.1-7 7-7" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path d="M17 14v2m0 2v.5" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" />
    <circle cx="17" cy="20.5" r="1" fill="currentColor" />
    <circle cx="17" cy="17" r="4.5" stroke="currentColor" strokeWidth={1.8} />
  </svg>
);

export const DEFAULT_TOKEN_ICONS = [IconSparkleLg, IconCheck, IconTarget, IconLineUp];

export const DizzarooLogo = (p: SVGProps<SVGSVGElement>) => (
  <svg width={22} height={22} viewBox="0 0 28 28" {...base} {...p}>
    <line x1="9"  y1="13.2" x2="9"  y2="14.8" stroke="white" strokeWidth={1.3} strokeLinecap="round" opacity={0.65} />
    <line x1="14" y1="13.2" x2="14" y2="14.8" stroke="white" strokeWidth={1.3} strokeLinecap="round" opacity={0.65} />
    <line x1="19" y1="13.2" x2="19" y2="14.8" stroke="white" strokeWidth={1.3} strokeLinecap="round" opacity={0.65} />
    <path d="M5.2 5 H22.8 L5.2 13 H22.8" stroke="white" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5.2 15 H22.8 L5.2 23 H22.8" stroke="white" strokeWidth={2.4} strokeLinecap="round" strokeLinejoin="round" opacity={0.88} />
    <circle cx="5.2"  cy="5"  r="1.5" fill="white" />
    <circle cx="22.8" cy="23" r="1.5" fill="white" />
  </svg>
);

